class ReportDetailsCtrl
  @$inject: ["$rootScope", "$scope", "$state", "toasty", "editor", "$stateParams", "selector", "Report"]
  constructor: ($rootScope, $scope, $state, toasty, editor, $stateParams, selector, Report)->
    Report.get({_id: $stateParams._id}).$promise.then (result)=>
      $scope.report = result
      $scope.dirty = angular.copy(result)
      if result.type is "CONNECTION"

        if result.receivers and result.receivers.length isnt 0
          $scope.advance = false
        else
          {online, offline} = result
          if angular.equals(online?.receivers, offline?.receivers)
            $scope.dirty.$advance = false
          else
            $scope.dirty.$advance = true

    $scope.schema =
      name:
        type: "String"
        display: "Report Name"
        required: true
      active:
        type: "Boolean"
        display: "Active"
        required: true

    $scope.assignDevices = ($resource)->
      options =
        model: "Device"
        filter: {}

      selector.select(options).then (devices)->
        devices.forEach (device)->
          $scope.dirty.$assignDevice device
        $resource.move(1)

    $scope.unassign = (source, resources)->
      idx = resources.indexOf(source)
      resources.splice(idx, 1)

    $scope.save = (report)=>
      if $scope.dirty.$advance
        $scope.dirty.receivers = undefined
        if $scope.dirty.online.receivers.length is 0 and $scope.dirty.offline.receivers.length is 0
          toasty.warning
            title: "Email receiver is required"
            msg: "Please insert the email address of the report receiver"
          return
      else
        if $scope.dirty.receivers.length is 0
          toasty.warning
            title: "Email receiver is required"
            msg: "Please insert the email address of the report receiver"
          return
      report.$save().then ()=>
        {online, offline} = report
        if angular.equals(online?.receivers, offline?.receivers)
            $scope.dirty.$advance = false
        else
          $scope.dirty.$advance = true
        toasty.success
          title: "Save Report Success"
          msg: "Save Report #{report.name} success"
    $scope.remove = (report)=>
      report.$remove().then ()->
        toasty.success
          title: 'Remove Success'
          msg: "Report removed"
        $state.go "reports"

module.exports = ReportDetailsCtrl




// WEBPACK FOOTER //
// ./src/component/report/details/controller.coffee